export default __webpack_public_path__ + "static/media/default.c0232b5f.jpg";